import * as React from "react";
import BackLink from "../../../components/atoms/BackLink";
import { BlockRow } from "../../../components/atoms/BlockRow";
import { MainSection, PageHeader } from "../../../components/atoms/MainSection";
import { OutletContextProps } from "../../../helpers/RouterHelper";
import enhanceSectionsSettingsPage, {
  SectionsSettingsPageProps,
} from "../../../hocs/enhanceSectionsSettingsPage";
import SectionInterface from "../../../interfaces/SectionInterface";
import { CourseShareForm } from "./CourseShareForm";

type Props = SectionsSettingsPageProps &
  OutletContextProps & {
    section: SectionInterface;
  };

const SectionsSettingsContentCoursesSharePage_: React.FC<Props> = (props) => {
  React.useEffect(() => {
    props.setActiveMenu("courses");
  }, []);
  return (
    <>
      <BackLink path={`/sections/${props.section.id}/settings/content_courses`}>
        戻る
      </BackLink>
      <BlockRow marginTop="2.4rem">
        <MainSection>
          <PageHeader helpUrl="https://fs-help.studyplus.co.jp/ja/articles/4964875">
            他教室のコース登録
          </PageHeader>
          <CourseShareForm sectionId={props.section.id} />
        </MainSection>
      </BlockRow>
    </>
  );
};
const pageInfo = {
  title: "他教室のコース登録",
};

export const SectionsSettingsContentCoursesSharePage =
  enhanceSectionsSettingsPage(
    SectionsSettingsContentCoursesSharePage_,
    pageInfo,
    ["content_courses"],
  );
